(function () {
  function stripHiddenText(el) {
    const clone = el.cloneNode(true);
    clone.querySelectorAll('.visually-hidden').forEach((node) => node.remove());
    return clone.textContent.trim();
  }

  function enrichMeasurementLabels(text) {
    const titleEl = document.querySelector('.product__title h1, .product__title');
    const title = titleEl ? titleEl.textContent : '';

    if (/gürtel/i.test(title)) {
      return text
        .replace(/Gesamtlänge(?!\s*\()/i, 'Gesamtlänge (A)')
        .replace(/Breite(?!\s*\()/i, 'Breite (B)');
    }
    if (/tasche/i.test(title)) {
      return text
        .replace(/Breite(?!\s*\()/i, 'Breite (A)')
        .replace(/Höhe(?!\s*\()/i, 'Höhe (B)');
    }
    return text;
  }

  function init() {
    document.querySelectorAll('variant-selects').forEach((variantSelects) => {
      const radios = variantSelects.querySelectorAll('input[type="radio"]');
      if (radios.length !== 1) return;

      const fieldset = variantSelects.querySelector('fieldset');
      const label = fieldset ? fieldset.querySelector('label') : null;
      if (!label) return;

      const legend = fieldset.querySelector('legend');
      const optionName = legend ? stripHiddenText(legend) : 'Maße';
      const optionValue = enrichMeasurementLabels(stripHiddenText(label));
      if (!optionValue) return;

      variantSelects.style.display = 'none';

      const firstAccordion = document.querySelector('.product__accordion');
      if (!firstAccordion || !firstAccordion.parentElement) return;

      const wrapper = document.createElement('div');
      wrapper.className = 'product__accordion accordion quick-add-hidden';
      wrapper.innerHTML =
        '<details>' +
        '<summary>' +
        '<div class="summary__title">' +
        '<span class="svg-wrapper">' + (window.__measurementsRulerIcon || '') + '</span>' +
        '<h2 class="h4 accordion__title inline-richtext">' + optionName + '</h2>' +
        '</div>' +
        (window.__measurementsCaretIcon || '') +
        '</summary>' +
        '<div class="accordion__content rte"><p>' + optionValue + '</p></div>' +
        '</details>';

      firstAccordion.parentElement.insertBefore(wrapper, firstAccordion);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
